import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../../widgets';
import BotonComponent from '../../dashboard/components/BotonNuevo';
import {
  allTemasAcademicosAction,
  setActivoTemasAcademicosAction,
} from './TemasAcademicosAction';
import AsignarMaterias from './components/AsignarMaterias';
import FormTemasAcademicos from './components/FormTemasAcademicos';
import ListadoTemasAcademicos from './components/ListadoTemasAcademicos';

const TemasAcademicosView = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const temasAcademicosStore = Redux.useSelector(
    (state) => state.temasAcademicos,
  );

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        {loginStore.isTeacher && (
          <BotonComponent
            click={async () => {
              await setActivoTemasAcademicosAction(dispatch, null);
              setOpenModalForm(true);
            }}
            green
            mr={2}
            addIcon
          />
        )}
        {temasAcademicosStore.all.length > 0 ? (
          <BotonComponent
            click={async () => {
              await setActivoTemasAcademicosAction(dispatch, null);
              await allTemasAcademicosAction(
                dispatch,
                temasAcademicosStore.params,
              );
            }}
            disabled={temasAcademicosStore.loadingAll}
            white
            refreshIcon
            text={
              temasAcademicosStore.loadingAll ? 'Actualizando...' : 'Actualizar'
            }
          />
        ) : null}
      </Grid>
      <Grid item md={12}>
        <ListadoTemasAcademicos
          setOpenModalForm={(value) => setOpenModalForm(value)}
        />
      </Grid>
      <ModalComponent
        id="modalFormTemasAcademicos"
        title={`${
          temasAcademicosStore.activo
            ? `Editar tema académico: ${temasAcademicosStore.activo.titulo}`
            : 'Nuevo tema académico'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {temasAcademicosStore.activo ? (
          <AsignarMaterias
            setOpenModalForm={(value) => setOpenModalForm(value)}
          />
        ) : (
          <FormTemasAcademicos
            activo={temasAcademicosStore.activo}
            setOpenModalForm={(value) => setOpenModalForm(value)}
          />
        )}
      </ModalComponent>
    </Grid>
  );
};

export default TemasAcademicosView;
